import {useSuspenseQuery} from '@tanstack/react-query';
import {injectAlphabeticalSort, prepareSearchParams} from 'shared';

import {api} from '@/lib/ky';
import {extractPagination} from '@/utils/extractPagination';

import {userListSchema} from '../utils/schemas/user';

import {userKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getUsers = async (params: QueryParams = {}) => {
  const res = await api.get(`users`, {
    searchParams: prepareSearchParams(injectAlphabeticalSort(params, 'name')),
  });
  const data = await res.json();
  const pagination = extractPagination(res);
  return [userListSchema.parse(data), pagination] as const;
};

export const useUsers = (
  params?: QueryParams,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: userKeys.list(params),
    queryFn: () => getUsers(params),
  });
};
export const useUsersLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getUsers;
type QueryParams = Parameters<typeof userKeys.list>[0];
